import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const coughingUpBlood: AnswerPathTreeNode = {
  path: 'coughingUpBlood',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredCoughingUpBloodDetails }],
};
